export default {"src":"/login-app/[GIT_HASH]/_next/static/media/chevron_left.c396a6a3.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};